<template>
  <div>
    <v-card>
      <v-card-title>
        <v-layout justify-space-between wrap>
          <slot name="selectMenu"></slot>

          <v-flex xs12 sm5>
            <v-text-field
              v-model="filter"
              append-icon="filter_list"
              label="Filtre"
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm2>
            <v-checkbox
              v-model="onlyGranted"
              label="Sadece verilenler"
              primary
            ></v-checkbox>
          </v-flex>
        </v-layout>
      </v-card-title>

      <v-card-text>
        <v-data-table
          :no-data-text="
            $store.state.query.loading ? '...yükleniyor' : $vuetify.noDataText
          "
          :headers="headers"
          :items="permissionlist"
          :footer-props="{ 'items-per-page-options': rowsPerPage }"
          :search="filter"
          :custom-filter="permSearch"
        >
          <template #item.actions="{ item }">
            <v-menu>
              <template #activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="editPermission(item)">
                  <v-list-item-title> Yetkiyi Düzenle </v-list-item-title>
                </v-list-item>
                <v-list-item @click="confirmDeletion(item)">
                  <v-list-item-title> Yetkiyi Kaldır </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>

          <!-- ✅ Yetki sütunu: Üstte TR, altta key, hover ile TR açıklama -->
          <template #item.permname="{ item }">
            <v-tooltip bottom v-if="getPermDesc(item.permname, item.permdesc)">
              <template #activator="{ on, attrs }">
                <div
                  v-bind="attrs"
                  v-on="on"
                  style="cursor: help; line-height: 1.1; padding: 6px 0"
                >
                  <div style="font-weight: 600">
                    {{ getPermTitle(item.permname) }}
                  </div>
                  <div style="opacity: 0.75; font-size: 12px">
                    {{ item.permname }}
                  </div>
                </div>
              </template>
              <span>{{ getPermDesc(item.permname, item.permdesc) }}</span>
            </v-tooltip>

            <div v-else style="line-height: 1.1; padding: 6px 0">
              <div style="font-weight: 600">
                {{ getPermTitle(item.permname) }}
              </div>
              <div style="opacity: 0.75; font-size: 12px">
                {{ item.permname }}
              </div>
            </div>
          </template>

          <template
            v-if="editableContent.includes('permvalue')"
            #item.permvalue="{ item }"
          >
            {{ item.permvalue }}
          </template>

          <template
            v-if="editableContent.includes('permskip')"
            #item.permskip="{ item }"
          >
            <v-simple-checkbox
              v-if="typeof item.permskip !== 'object'"
              :value="!!item.permskip"
              disabled
            ></v-simple-checkbox>
          </template>

          <template
            v-if="editableContent.includes('permnegated')"
            #item.permnegated="{ item }"
          >
            <v-simple-checkbox
              v-if="typeof item.permnegated !== 'object'"
              :value="!!item.permnegated"
              disabled
            ></v-simple-checkbox>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <!-- ✅ Yetki Düzenle Popup: SADECE 2 SATIR (TR Ad + TR Açıklama) -->
    <v-dialog v-model="dialog" max-width="520px">
      <v-card>
        <v-card-title>
          {{ getPermTitle(editedPermission.permname) }}
        </v-card-title>

        <v-card-subtitle
          v-if="
            getPermDesc(editedPermission.permname, editedPermission.permdesc)
          "
          style="margin-top: -10px"
        >
          <span style="opacity: 0.75">
            {{
              getPermDesc(editedPermission.permname, editedPermission.permdesc)
            }}
          </span>
        </v-card-subtitle>

        <v-card-text>
          <v-layout wrap justify-space-between>
            <v-flex xs12 v-if="editableContent.includes('permvalue')">
              <v-text-field
                label="Değer"
                type="number"
                v-model="editedPermission.permvalue"
              ></v-text-field>
            </v-flex>

            <v-flex xs5 v-if="editableContent.includes('permskip')">
              <v-checkbox
                label="Atla"
                v-model="editedPermission.permskip"
              ></v-checkbox>
            </v-flex>

            <v-flex xs5 v-if="editableContent.includes('permnegated')">
              <v-checkbox
                label="Negatif"
                v-model="editedPermission.permnegated"
                :disabled="type === 'Client Permissions' ? true : false"
              ></v-checkbox>
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="savePermission" color="primary">Kaydet</v-btn>
          <v-btn text @click="dialog = false" color="primary">İptal</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Silme Popup -->
    <v-dialog v-model="deleteDialog" max-width="520px">
      <v-card>
        <v-card-title>Yetkiyi Kaldır</v-card-title>
        <v-card-text>
          <b>{{ getPermTitle(editedPermission.permname) }}</b>

          <div style="opacity: 0.75; font-size: 12px; margin-top: 4px">
            {{ editedPermission.permname }}
          </div>

          <div
            v-if="
              getPermDesc(editedPermission.permname, editedPermission.permdesc)
            "
            style="opacity: 0.75; font-size: 12px; margin-top: 4px"
          >
            {{
              getPermDesc(editedPermission.permname, editedPermission.permdesc)
            }}
          </div>

          <div style="margin-top: 10px">
            Yetkisinin değerlerini kaldırmak istediğine emin misin?
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="removePermission" color="primary">Evet</v-btn>
          <v-btn text @click="deleteDialog = false" color="primary"
            >İptal</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { PERM_TR } from "@/assets/permissions.tr";

export default {
  props: {
    type: String,
    grantedPermissions: Array,
    editableContent: Array,
  },
  data() {
    return {
      availablePermissions: [],
      onlyGranted: true,
      availableHeaders: [
        { text: "", align: "start", value: "actions", sortable: false },
        { text: "Yetki", align: "left", value: "permname", sortable: false },
        { text: "Değer", align: "left", value: "permvalue", sortable: false },
        { text: "Atla", align: "left", value: "permskip", sortable: false },
        {
          text: "Negatif",
          align: "left",
          value: "permnegated",
          sortable: false,
        },
      ],
      rowsPerPage: [50, 100, 150, -1],
      filter: "",
      dialog: false,
      deleteDialog: false,
      editedPermission: {
        permdesc: "",
        permname: "",
        permid: null,
        permnegated: null,
        permskip: null,
        permvalue: null,
      },
    };
  },
  computed: {
    permissionlist() {
      var list = this.availablePermissions.map((permission) => {
        var found = this.grantedPermissions.find(
          (perm) => perm.permid === permission.permid
        );

        var permissionValues = found
          ? found
          : { permvalue: null, permnegated: null, permskip: null };

        return { ...permission, ...permissionValues };
      });

      if (this.onlyGranted) return list.filter((p) => p.permvalue !== null);
      return list;
    },
    headers() {
      return this.availableHeaders.filter((header) => {
        for (var i = 0; i < this.editableContent.length; i++) {
          var value = this.editableContent[i];
          if (
            header.value === value ||
            header.value === "permname" ||
            header.value === "actions"
          ) {
            return header;
          }
        }
      });
    },
  },
  methods: {
    // ✅ Başlık: TR varsa TR, yoksa key
    getPermTitle(key) {
      var row = PERM_TR[key];
      if (row && row.tr) return row.tr;
      return key;
    },

    // ✅ Açıklama: TR açıklama varsa TR, yoksa component'in item.permdesc (EN)
    getPermDesc(key, fallbackEn) {
      var row = PERM_TR[key];
      if (row && row.desc_tr) return row.desc_tr;
      return fallbackEn || "";
    },

    // ✅ Filtre: key + TR başlık + TR açıklama + EN açıklama
    permSearch(value, search, item) {
      var q = (search || "").toString().toLowerCase().trim();
      if (!q) return true;

      var key = item && item.permname ? item.permname : "";
      var descEn = item && item.permdesc ? item.permdesc : "";

      var titleTr = this.getPermTitle(key);
      var descTr = this.getPermDesc(key, "");

      var a = key.toLowerCase();
      var b = (titleTr || "").toLowerCase();
      var c = (descTr || "").toLowerCase();
      var d = (descEn || "").toLowerCase();

      return a.includes(q) || b.includes(q) || c.includes(q) || d.includes(q);
    },

    getPermissionlist() {
      return this.$TeamSpeak.execute("permissionlist");
    },

    editPermission(permissionValues) {
      this.editedPermission = { ...permissionValues };
      this.editedPermission.permskip = Boolean(
        parseInt(this.editedPermission.permskip)
      );
      this.editedPermission.permnegated = Boolean(
        parseInt(this.editedPermission.permnegated)
      );
      this.dialog = true;
    },

    savePermission() {
      this.$emit("save", this.editedPermission);
      this.dialog = false;
    },

    confirmDeletion(permissionValues) {
      this.editedPermission = { ...permissionValues };
      this.deleteDialog = true;
    },

    removePermission() {
      this.$emit("remove", this.editedPermission);
      this.deleteDialog = false;
    },
  },
  async created() {
    try {
      this.availablePermissions = await this.getPermissionlist();
      this.$emit("loaded");
    } catch (err) {
      this.$toast.error(err.message);
    }
  },
};
</script>
